import { styled } from '@mui/material/styles';

const AuthWrapper1 = styled('div')(({ theme }) => ({
  background: '#18191d',
  minHeight: '100vh',
  overflowY: 'scroll'
}));

export default AuthWrapper1;